var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn text-uppercase btn-outline-success",class:_vm.btnStyle,attrs:{"type":"submit"}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }